/**
 * hotspotRowFormat — Stream H (R4) / hotspots-final
 *
 * Kleine reine Formatierungs-Helfer, die sowohl HotspotRow (eigene Liste)
 * als auch die Watched-Sektion in HotspotsList (Prototyp hotspots.html
 * #watched-list) brauchen. Eigene Datei statt Re-Export aus HotspotRow.tsx,
 * weil react-refresh/only-export-components sonst den Fast-Refresh einer
 * Komponentendatei mit gemischten Exporten ablehnt.
 */
import type { HotspotStatus } from './useHotspots'

export function formatHnt(value: number | null | undefined): string {
  if (value == null) return '—'
  return value.toFixed(3)
}

export const STATUS_PILL_VARIANT: Record<HotspotStatus, 'success' | 'warning' | 'danger'> = {
  online: 'success',
  warn: 'warning',
  offline: 'danger',
}

export function statusLabel(status: HotspotStatus, online_pct: number, t: (key: string) => string): string {
  const labels: Record<HotspotStatus, string> = {
    online: t('row.status.online'),
    warn: t('row.status.degraded'),
    offline: t('row.status.offline'),
  }
  const label = labels[status] ?? status
  // F-SW7-11 (AC4): status="online" bei online_pct=0 ist ein Backend-Denorm-
  // Widerspruch (Ursache: fehlende Uptime-Denorm-Pflege, F-SW7-13/sweep7-e5-be-1
  // — vgl. useHotspots.ts:97 normalizeHotspot online_pct-Default). Statt eines
  // irreführenden "0.0% Online" wird das Prozent-Suffix in diesem Fall
  // weggelassen (Empty-/Unbekannt-Zustand statt fiktivem 0%).
  const suppressPct = status === 'online' && (online_pct ?? 0) === 0
  return suppressPct ? label : `${label} · ${(online_pct ?? 0).toFixed(1)}%`
}
